<ng-container *transloco="let t;">
<div>
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center content-sidebar-header py-75 px-1 mt-50">
        <div class="linked-organization-inner">
            <div class="d-flex justify-content-start align-items-center">
                <div class="user-page-info">
                    <h5 class="mb-0">
                        {{t("Content box settings label (Template/Document - section) - Content box settings")}}
                    </h5>
                </div>
            </div>
        </div>
        <div class="cursor-pointer closeMenu" (click)="close()">
            <i data-feather="x" [size]="16" class="ms-0"></i>
        </div>
    </div>
    <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="contentbox-setting-scroll-container">
    <div>
        <div class="px-1">
            <label class="col-form-label pt-0">{{t("Content box settings background image text (Template/Document - section) - Background Image")}}</label>
            <div class="background-wrapper file-drop-zone" *ngIf="!background_image" (click)="background_image.click()">
                <span>{{t("Content box settings click to upload text (Template/Document - section) - Click to upload")}}</span>
                <input hidden type="file" #background_image (change)="backgroundImage($event)" accept="image/png, image/jpeg, image/jpg" />
            </div>
            <div class="background-wrapper file-drop-zone content-image" *ngIf="background_image" [ngStyle]="{'background-image': 'url(' + background_image + ')'}">
                <div class="delete-img" (click)="removeBackgroundImage()">
                    <i data-feather="trash" [size]="14"></i>
                </div>
            </div>
        </div>

        <div class="px-1">
            <hr class="mb-2 mt-2" />
        </div>

        <div class="form-group px-1 mt-0 conditional-dropdown">
            <app-conditional-fields
                [uuid]="data['uuid']"
                [block]="contentData"
            ></app-conditional-fields>
        </div>

        <div class="form-group px-1">
            <label class="col-form-label pt-0" for="name">{{t("Content box settings allow role to edit text (Template/Document - section) - Allow role to edit")}}</label>
            <div class="custum-dropdown-field-type">
                <ng-select #roleSelecter [(ngModel)]="role_id" [items]="generalPopoverSettings.selectRole" bindLabel="name" bindValue="id" [searchable]="true" placeholder="Select role" [clearable]="false" (change)="selectRole($event)">
                    <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div>
                            <div class="">
                                <span class="">{{ item.name }}</span>
                                <span class="field-type-label">{{ item.recipient }}</span>
                            </div>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
        </div>
    </div>
    <app-lock-field 
        type="block"
        [uuid]="data['uuid']"
        (lockChange)="onLockChange($event)"
        >
    </app-lock-field>
    </ng-scrollbar>
</div>
</ng-container>
